import type { CalendarEvent } from 'owa-calendar-types';
import type { ClientItemId } from 'owa-client-ids';
import fetchCalendarEventAndSubscribe from './fetchCalendarEventAndSubscribe';
import type {
    LockedCalendarEventsStore,
    LockedCalendarEventsReader,
} from 'owa-calendar-events-store';

export default function getCalendarEvent(
    itemId: string | ClientItemId,
    onNotFoundError: () => void,
    store: LockedCalendarEventsStore,
    storeReader: LockedCalendarEventsReader
): Readonly<CalendarEvent> | null {
    const clientId = typeof itemId === 'string' ? ({ Id: itemId } as ClientItemId) : itemId;

    const event = storeReader.getFullCalendarEvent(null, clientId.Id);
    if (!event) {
        fetchCalendarEventAndSubscribe(clientId, onNotFoundError, store);
    }

    return event;
}
